import { FormattedMessage } from 'react-intl';

import { CallToAction } from '$HVUI';

/**
 * Wrapper component for FormattedMessage: https://formatjs.io/docs/react-intl/components#formattedmessage
 * This component should only be used for rendering links.
 * @param {string} href link location
 * @param {string} htmlId `id` attribute that will be set on the link
 * @param {string} [target=_self] target attribute, in case you want to set _blank or something
 * @param {object} values object describing substitutions and formatting.
 * @example
 * ```
 * <IntlLink id="test" href="#" values={{ mySubstitutionKey: mySubstitutionValue }} />
 * ```
 */

const IntlLink = props => {
    const { href, htmlId, target = '_self' } = props;
    return (
        <FormattedMessage
            {...props}
            values={{
                link: chunks => (
                    <CallToAction {...props} element="link" text={chunks} />
                ),
                exLink: chunks => (
                    <a href={href} target={target} id={htmlId || null}>
                        {chunks}
                    </a>
                )
            }}
        />
    );
};

export default IntlLink;
